<app-breadcrumb
  [title]="'notifications.pageTitle' | translate"
  [items]="['notifications.breadcrumbDashboard' | translate]"
  [active_item]="'notifications.pageTitle' | translate">
</app-breadcrumb>

<div class="container-fluid notif-page">
  <ul class="notif-page__tabs" role="tablist">
    <li>
      <button type="button" class="notif-page__tab" routerLink="/dashboard/notifications">
        <app-feather-icons icon="inbox"></app-feather-icons>
        {{ 'notifications.center.tabInbox' | translate }}
      </button>
    </li>
    <li>
      <button
        type="button"
        class="notif-page__tab"
        [class.notif-page__tab--active]="activeTab === 'push'"
        (click)="activeTab = 'push'"
      >
        <app-feather-icons icon="bell"></app-feather-icons>
        {{ 'notifications.pushSettingsTab' | translate }}
      </button>
    </li>
    <li *ngIf="officeIdNumber !== null">
      <button
        type="button"
        class="notif-page__tab"
        [class.notif-page__tab--active]="activeTab === 'requests'"
        (click)="activeTab = 'requests'"
      >
        <app-feather-icons icon="inbox"></app-feather-icons>
        {{ 'notifications.companyRequestsTab' | translate }}
        <span class="notif-page__badge" *ngIf="total > 0">{{ total }}</span>
      </button>
    </li>
  </ul>

  <!-- Push notifications (this device) -->
  <div class="card notif-page__card" *ngIf="activeTab === 'push'">
    <div class="card-body">
      <app-push-device-settings></app-push-device-settings>
    </div>
  </div>

  <!-- Company permission requests (office users) -->
  <div class="card notif-page__card" *ngIf="activeTab === 'requests' && officeIdNumber !== null">
    <div class="notif-page__card-header">
      <div>
        <h5 class="notif-page__card-title">{{ 'notifications.companyRequestsTitle' | translate }}</h5>
        <p class="notif-page__card-sub">{{ 'notifications.companyRequestsSub' | translate }}</p>
      </div>
      <div class="notif-page__bulk-actions" *ngIf="notificationsData.length > 0">
        <button class="btn notif-page__btn notif-page__btn--accept" (click)="openVerticallyCenteredConfirmedAll(dataConfirmAl)">
          <i class="fa fa-check-circle-o"></i>
          {{ 'notifications.acceptAll' | translate }}
        </button>
        <button class="btn notif-page__btn notif-page__btn--reject" (click)="openVerticallyCenteredRejectedAll(dataRejectAll)">
          <i class="fa fa-times-circle"></i>
          {{ 'notifications.rejectAll' | translate }}
        </button>
      </div>
    </div>

    <div class="card-body pt-0">
      <div class="notif-page__empty" *ngIf="notificationsData.length === 0">
        <app-feather-icons icon="inbox"></app-feather-icons>
        <p>{{ 'notifications.noCompanyRequests' | translate }}</p>
      </div>

      <div class="table-responsive notif-page__table-wrap" *ngIf="notificationsData.length > 0">
        <table class="table notif-page__table align-middle">
          <thead>
            <tr>
              <th>{{ 'notifications.colLogo' | translate }}</th>
              <th>{{ 'notifications.colCompany' | translate }}</th>
              <th>{{ 'notifications.colMerchant' | translate }}</th>
              <th>{{ 'notifications.colMessage' | translate }}</th>
              <th class="text-center">{{ 'notifications.colActions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of notificationsData | paginate: {itemsPerPage: limit, currentPage: currentPage, totalItems: total}">
              <td>
                <img
                  class="notif-page__logo"
                  [src]="item?.company?.logo_url"
                  alt="logo"
                  onerror="this.src='assets/images/logo/logo.png'"
                />
              </td>
              <td class="notif-page__company-name">
                {{ (item?.company | companyName:curentLang) }}
              </td>
              <td>
                {{ curentLang === 'en' ? item?.merchant?.merchant_name_en : (curentLang === 'ar' ? item?.merchant?.merchant_name_ar : item?.merchant?.merchant_name_he) }}
              </td>
              <td class="notif-page__message">{{ getMessage(item, curentLang) }}</td>
              <td>
                <div class="notif-page__row-actions">
                  <button
                    class="btn notif-page__btn notif-page__btn--accept btn-sm"
                    (click)="getId(item?.permission_id); openVerticallyCenteredConfirmed(dataConfirm)"
                  >
                    <i class="fa fa-check-circle-o"></i>
                    {{ 'notifications.confirm' | translate }}
                  </button>
                  <button
                    class="btn notif-page__btn notif-page__btn--reject btn-sm"
                    (click)="getId(item?.permission_id); openVerticallyCenteredRejected(dataReject)"
                  >
                    <i class="fa fa-times-circle"></i>
                    {{ 'notifications.reject' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="notif-page__pagination">
          <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
          <div class="notif-page__page-size">
            <label>{{ 'notifications.rowsPerPage' | translate }}</label>
            <input type="number" min="1" max="100" [(ngModel)]="customLimit" (change)="onLimitChange()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirm single -->
<ng-template #dataConfirm let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">{{ 'notifications.confirmOfferTitle' | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">{{ 'notifications.confirmOfferBody' | translate }}</p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn notif-page__btn notif-page__btn--accept" (click)="changeCompanyPermissionStatus()">
      {{ 'notifications.confirm' | translate }}
    </button>
    <button type="button" class="btn btn-light" (click)="modal.close()">{{ 'notifications.back' | translate }}</button>
  </div>
</ng-template>

<!-- Reject single -->
<ng-template #dataReject let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">{{ 'notifications.rejectOfferTitle' | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">{{ 'notifications.rejectOfferBody' | translate }}</p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn notif-page__btn notif-page__btn--reject" (click)="changeCompanyPermissionStatusReject()">
      {{ 'notifications.reject' | translate }}
    </button>
    <button type="button" class="btn btn-light" (click)="modal.close()">{{ 'notifications.back' | translate }}</button>
  </div>
</ng-template>

<!-- Confirm all -->
<ng-template #dataConfirmAl let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">{{ 'notifications.confirmAllTitle' | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">{{ 'notifications.confirmAllBody' | translate }}</p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn notif-page__btn notif-page__btn--accept" (click)="changeCompanyPermissionStatusAll()">
      {{ 'notifications.confirm' | translate }}
    </button>
    <button type="button" class="btn btn-light" (click)="modal.close()">{{ 'notifications.back' | translate }}</button>
  </div>
</ng-template>

<!-- Reject all -->
<ng-template #dataRejectAll let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title">{{ 'notifications.rejectAllTitle' | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">{{ 'notifications.rejectAllBody' | translate }}</p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn notif-page__btn notif-page__btn--reject" (click)="changeCompanyPermissionStatusRejectAll()">
      {{ 'notifications.reject' | translate }}
    </button>
    <button type="button" class="btn btn-light" (click)="modal.close()">{{ 'notifications.back' | translate }}</button>
  </div>
</ng-template>
